import { DegradationCurveParameters } from 'src/app/degradation/models/degradation-curve';
import { Util } from "@phdsoft/common";
import { ELEMENTSTYPESIDS } from "projects/phdsoft/common/src/lib/shared/constants/elementsTypesIds";
import { ExecutionStatus } from "../../DomainEntity";
import { Material } from "../../ResourceElements/Material";
import { MaterialSubType } from "../../ResourceElements/MaterialSubType";
import { MaterialType } from "../../ResourceElements/MaterialType";
import { GaugingElement } from "../InspectionElements/gaugingElement";
// import { SteelThicknessGaugingPoint } from "../InspectionElements/steelThicknessGaugingPoint";
import { WorkableElement } from "../WorkableElement";
import { GeometryModel } from 'projects/phdsoft/common/src/lib/models/repairmodels/repair.model';
import { INSPECTIONS_TYPES_IDS } from 'projects/phdsoft/common/src/lib/shared/constants/inspections-types-ids';
import * as THREE from '@phdsoft/three';

export abstract class StructuralElement extends WorkableElement {

    private static _excessiveCorrosionMaterial: THREE.Material;
    public static get excessiveCorrosionMaterial(): THREE.Material {
        return this._excessiveCorrosionMaterial;
    }
    public static set excessiveCorrosionMaterial(v: THREE.Material) {
        this._excessiveCorrosionMaterial = v;
    }
 
    private static _substantialCorrosionMaterial: THREE.Material;
    public static get substantialCorrosionMaterial(): THREE.Material {
        return this._substantialCorrosionMaterial;
    }
    public static set substantialCorrosionMaterial(v: THREE.Material) {
        this._substantialCorrosionMaterial = v;
    }

    private static _acceptableCorrosionMaterial: THREE.Material;
    public static get acceptableCorrosionMaterial(): THREE.Material {
        return this._acceptableCorrosionMaterial;
    }
    public static set acceptableCorrosionMaterial(v: THREE.Material) {
        this._acceptableCorrosionMaterial = v;
    }

    private _admissibleCorrosion: number;
    public get admissibleCorrosion(): number {
        return this._admissibleCorrosion ?? this.properties?.Geometry?.WastageAllowance ?? 20;
    }
    public set admissibleCorrosion(v: number) {
        this._admissibleCorrosion = v;
    }
    private _admissibleFractureLength: number;
    public get AdmissibleFractureLength(): number {
        return this._admissibleFractureLength;
    }
    public set AdmissibleFractureLength(v: number) {
        this._admissibleFractureLength = v;
    }

    private _pressure: number;
    public get Pressure(): number {
        return this._pressure;
    }
    public set Pressure(v: number) {
        this._pressure = v;
    }

    private _Temperature: number;
    public get Temperature(): number {
        return this._Temperature;
    }
    public set Temperature(v: number) {
        this._Temperature = v;
    }

    private _DesignPressure: number;
    public get DesignPressure(): number {
        return this._DesignPressure;
    }
    public set DesignPressure(v: number) {
        this._DesignPressure = v;
    }



    private _MaterialType: MaterialType;
    public get MaterialType(): MaterialType {
        return this._MaterialType;
    }
    public set MaterialType(v: MaterialType) {
        this._MaterialType = v;
    }

    private _Geometries: Array<{ id: string, geometryModel: GeometryModel, date: Date }>;
    public get Geometries(): Array<{ id: string, geometryModel: GeometryModel, date: Date }> {
        return this._Geometries;
    }
    public set Geometries(v: Array<{ id: string, geometryModel: GeometryModel, date: Date }>) {
        this._Geometries = v;
    }

    /**
     * Stores the original geometry before any cuts were applied.
     * Used to restore the element when all cuts are deleted.
     */
    private _originalGeometry: THREE.BufferGeometry;
    public get originalGeometry(): THREE.BufferGeometry {
        return this._originalGeometry;
    }
    public set originalGeometry(v: THREE.BufferGeometry) {
        this._originalGeometry = v;
    }

    private _MaterialSubType: MaterialSubType;
    public get MaterialSubType(): MaterialSubType {
        return this._MaterialSubType;
    }
    public set MaterialSubType(v: MaterialSubType) {
        this._MaterialSubType = v;
    }

    private _thickness: number;
    public get thickness(): number {
        return this._thickness;
    }
    public set thickness(v: number) {
        this._thickness = v;
    }


    private _flangeThickness: number;
    public get flangeThickness(): number {
        return this._flangeThickness;
    }
    public set flangeThickness(v: number) {
        this._flangeThickness = v;
    }


    private _flangeRuleThickness: number;
    public get flangeRuleThickness(): number {
        return this._flangeRuleThickness;
    }
    public set flangeRuleThickness(v: number) {
        this._flangeRuleThickness = v;
    }


    private _ruleThickness: number;
    public get ruleThickness(): number {
        return this._ruleThickness ?? this._thickness;
    }
    public set ruleThickness(v: number) {
        this._ruleThickness = v;
    }


    private _isExecuted: boolean = true;
    public get isExecuted(): boolean {
        return this._isExecuted;
    }
    public set isExecuted(v: boolean) {
        if (v) {
            this.currentMaterial = this.executedMaterial;
            this.defaultMaterial = this.executedMaterial;
            for (const inspection of this._inspectionsSolved) {
                inspection.active = false;
            }
        }
        else {
            this.currentMaterial = this.outlinedMaterial;
            this.defaultMaterial = this.outlinedMaterial;
            for (const inspection of this._inspectionsSolved) {
                inspection.active = true;
            }
        }
        this._isExecuted = v;
    }

    public setExecutedMaterial(v: boolean) {
        if (v) {
            this.currentMaterial = this.executedMaterial;
            this.defaultMaterial = this.executedMaterial;
        }
        this._isExecuted = v;
    }

    private _executionStatus: ExecutionStatus;
    public get executionStatus(): ExecutionStatus {
        return this._executionStatus;
    }
    public set executionStatus(v: ExecutionStatus) {
        if (v === 'EXECUTED') {
            this.currentMaterial = this.executedMaterial;
            this.defaultMaterial = this.executedMaterial;
            for (const inspection of this._inspectionsSolved) {
                inspection.active = false;
            }
        }
        // else if (v === 'OUTLINED') {
        //     this.currentMaterial = this.executedMaterial;
        //     this.defaultMaterial = this.executedMaterial;
        //     for (const inspection of this._inspectionsSolved) {
        //         inspection.active = true;
        //     }
        // }
        this._executionStatus = v;
    }

    public setExecutionStatu(v: ExecutionStatus) {
        if (v === 'OUTLINED') {
            this.currentMaterial = this.executedMaterial;
            this.defaultMaterial = this.executedMaterial;
            for (const inspection of this._inspectionsSolved) {
                inspection.active = true;
            }
        }
        this._executionStatus = v;
    }

    private _inspectionsSolved: Array<GaugingElement> = new Array<GaugingElement>();
    public get inspectionsSolved(): Array<GaugingElement> {
        return this._inspectionsSolved;
    }
    public set inspectionsSolved(v: Array<GaugingElement>) {
        this._inspectionsSolved = v;
    }

    private _inspectionIds: Array<string>;
    public get inspectionIds(): Array<string> {
        return this._inspectionIds;
    }
    public set inspectionIds(v: Array<string>) {
        this._inspectionIds = v;
    }

    private _isRepair: boolean = false;
    public get isRepair(): boolean {
        return this._isRepair;
    }
    public set isRepair(v: boolean) {
        this._isRepair = v;
    }

    
    private _isDoubler : boolean = false;
    public get isDoubler() : boolean {
        return this._isDoubler;
    }
    public set isDoubler(v : boolean) {
        this._isDoubler = v;
    }
    

    private _targetId: string;
    public get targetId(): string {
        return this._targetId;
    }
    public set targetId(v: string) {
        this._targetId = v;
    }

    private _targetIds: Array<string>;
    public get targetIds(): Array<string> {
        return this._targetIds;
    }
    public set targetIds(v: Array<string>) {
        this._targetIds = v;
    }

    private _criticalAreaId: string;
    public get criticalAreaId(): string {
        return this._criticalAreaId;
    }
    public set criticalAreaId(v: string) {
        this._criticalAreaId = v;
    }

    private _nodesIds: Array<number>;
    public get nodesIds(): Array<number> {
        return this._nodesIds;
    }
    public set nodesIds(v: Array<number>) {
        this._nodesIds = v;
    }

    private _elementsIds: Array<number>;
    public get elementsIds(): Array<number> {
        return this._elementsIds;
    }
    public set elementsIds(v: Array<number>) {
        this._elementsIds = v;
    }

    private _elementTopology: Array<number>;
    public get elementTopology(): Array<number> {
        return this._elementTopology;
    }
    public set elementTopology(v: Array<number>) {
        this._elementTopology = v;
    }

    private _gaugingElements: Array<GaugingElement> = new Array<GaugingElement>();
    public get gaugingElements(): Array<GaugingElement> {
        return this._gaugingElements;
    }
    public set gaugingElements(v: Array<GaugingElement>) {
        this._gaugingElements = v;
    }

    public get meanThicknessValue(): number {
        var mean = 0
        // if (this.EstimatedThickness) {
        //     return this.EstimatedThickness
        // }
        if (this.thicknessGaugingPoints.length > 0 && this.thicknessGaugingPoints.filter(x => x.active && x.gaugingValue > 0).length > 0) {
            mean = this.thicknessGaugingPoints.map(x => x.active && x.gaugingValue)
                .filter(x => x > 0)
                .reduce((a, b) => a + b, 0) /
                this.thicknessGaugingPoints.filter(x => x.active && x.gaugingValue > 0).length
        }
        return mean
    }

    //#region New Degradation    
    private _degradationParameters : DegradationCurveParameters[] ;
    public get degradationParameters() : DegradationCurveParameters[]  {
        return this._degradationParameters;
    }
    public set degradationParameters(v : DegradationCurveParameters[] ) {
        this._degradationParameters = v;
    }
    

    public get substantialCorrosionThickness(): number {
        // if (!this.showDegradation) return null
        if (this.properties?.Geometry?.WastageAllowance && this.properties?.Geometry?.RuleThickness) {
          return Number((this.properties.Geometry.RuleThickness * (1 - 0.75 * (this.properties.Geometry.WastageAllowance / 100))).toFixed(2));
        }
    
        return Number(this._substantialCorrosionThickness?.toFixed(2));
      }
    
      public get excessiveCorrosionThickness(): number {
        // if (!this.showDegradation) return null
        if (this.properties?.Geometry?.WastageAllowance && this.properties?.Geometry?.RuleThickness) {
          return Number((this.properties.Geometry.RuleThickness * (1 - (this.properties.Geometry.WastageAllowance / 100))).toFixed(2));
        }
    
        return Number(this._excessiveCorrosionThickness?.toFixed(2));
      }
    
      public get absoluteDegradation(): number {
        // if (!this.showDegradation) return null
    
        if (this._degradationParameters.length > 0) {
          let sum = this._degradationParameters.reduce((prev, curr) => prev + curr.AbsoluteDegradation, 0);
          let average = sum / this._degradationParameters.length;
          return Number(average.toFixed(2));
        }
        return null
      }
    
      public get relativeDegradation(): number {
        // if (!this.showDegradation) return null
    
        if (this._degradationParameters.length > 0) {
          let sum = this._degradationParameters.reduce((prev, curr) => prev + curr.RelativeDegradation, 0);
          let average = sum / this._degradationParameters.length;
          return Number(average.toFixed(2));
        }
        return null
      }
    
      public get corrosionRate(): number {
        if (this._degradationParameters.length > 0) {
          let sum = this._degradationParameters.reduce((prev, curr) => prev + curr.CorrosionRate, 0);
          let average = sum / this._degradationParameters.length;
          // if (average == 0){
          //   this.showDegradation = false
          //   return null
          // }
          // this.showDegradation = true
          return Number(average.toFixed(2));
        }
        return null
      }
    
      public get remainingLife(): number {
        // if (!this.showDegradation) return null
    
        if (this._degradationParameters.length > 0) {
          let remainingLife = 0;
    
          if (this._degradationParameters.every(c => c.RemainingLife == Infinity)) {
            return Infinity
          }
          else {
            const rLCurves = this._degradationParameters.filter(c => c.RemainingLife != Infinity)
            remainingLife = (rLCurves.reduce((prev, curr) => prev + curr.RemainingLife, 0)) / rLCurves.length;
          }
    
          if (remainingLife < 0) {
            return 0
          }
    
          return Number(remainingLife.toFixed(2));
        }
        return null
      }
    
      public get estimatedThickness(): number {
        // if (!this.showDegradation) return null
    
        if (this._degradationParameters.length > 0) {
          let sum = this._degradationParameters.reduce((prev, curr) => prev + curr.EstimatedThickness, 0);
          let average = sum / this._degradationParameters.length;
          return Number(average.toFixed(2));
        }
        return null
      }
    
      public get readingQuality(): number {
        if (this._degradationParameters.length > 0) {
          return null;
        }
        return null
      }
    
      public get corrosionRiskIndex(): number {
        // if (!this.showDegradation) return null
    
        if (this._degradationParameters.length > 0) {
          // return (this.absoluteDegradation * 1).toFixed(2);
          return this.absoluteDegradation;
        }
        return null
      }

    //#endregion

    //#region Degradation

    // SubstantialCorrosionThickness?: number
    // ExcessiveCorrosionThickness?: number
    // AbsoluteDegradation?: number
    // RelativeDegradation?: number
    // CorrosionRate?: number
    // RemainingLife?: number
    // EstimatedThickness?: number
    // CorrosionRiskIndex?: number

    // DegradationParameters?: DegradationCurveParameters[]

    // public setDegradationProperties(degradationParameters: DegradationCurveParameters[], referenceDate: Date) {
    //     degradationParameters = degradationParameters.filter(p => p.ParentGeometryId == this.Guid)
    //     if (degradationParameters.length > 0) {
    //         this.DegradationParameters = degradationParameters
    //         this.setEstimatedThickness(referenceDate)
    //         this.setCorrosionRate(referenceDate)
    //         this.setRemainingLife(referenceDate)
    //         this.setAbsoluteDegradation()
    //         this.setCorrosionRiskIndex()
    //     }
    // }

    // private setEstimatedThickness(referenceDate: Date) {
    //     if (this.DegradationParameters) {
    //         let originalThickness = this.thickness
    //         const buildingDate = this.properties.General.Collection.Date
    //         const time = (new Date(referenceDate).getTime() - new Date(buildingDate).getTime()) / (1000 * 60 * 60 * 24)
    //         let thickness = 0
    //         let mean = 0
    //         this.DegradationParameters.forEach(p => {
    //             let estimatedThickness

    //             if (p.CurveType == "Linear") {
    //                 if (this.gaugingElements.length > 1) {
    //                     if (p.CurveParameters[0] != 0 || p.CurveParameters[1] != 0) {
    //                         const intercept = p.CurveParameters[0]
    //                         const slope = p.CurveParameters[1]
    //                         var estimatedLostThickness = intercept + (time * slope)
    //                         estimatedThickness = originalThickness - estimatedLostThickness
    //                         mean++
    //                     } else {
    //                         estimatedThickness = 0
    //                     }
    //                 } else {
    //                     if (Number(this.gaugingElements[0]?.gaugingValue) <= this.thickness) {
    //                         const intercept = p.CurveParameters[0]
    //                         const slope = p.CurveParameters[1]
    //                         var estimatedLostThickness = intercept + (time * slope)
    //                         estimatedThickness = originalThickness - estimatedLostThickness
    //                         mean++
    //                     } else {
    //                         thickness = null
    //                     }
    //                 }
    //             }
    //             else if (p.CurveType == "Exponential") {
    //                 const a = p.CurveParameters[0]
    //                 const b = p.CurveParameters[1]

    //                 var estimatedLostThickness = a * Math.pow(time, b)
    //                 estimatedThickness = originalThickness - estimatedLostThickness
    //                 mean++
    //             }
    //             if (thickness !== null) {
    //                 thickness = thickness + estimatedThickness
    //             } else {
    //                 thickness = thickness
    //             }
    //         })

    //         this.EstimatedThickness = thickness / mean
    //     }
    // }

    // private setRemainingLife(referenceDate: Date) {
    //     if (this.DegradationParameters) {
    //         if (this.CorrosionRate <= 0) {
    //             this.RemainingLife = Infinity
    //         } else {
    //             this.RemainingLife = 0
    //             const ruletk = this.ruleThickness
    //             const originalThickness = this.thickness
    //             const wastageAllowance: number = (this.properties.Geometry?.WastageAllowance ?? 20)?.toFixed(2);
    //             const excessiveCorrosionThickness = ruletk * (1 - (wastageAllowance / 100))
    //             const buildingDate = this.properties.General.Collection.Date
    //             const time = (new Date(referenceDate).getTime() - new Date(buildingDate).getTime()) / (1000 * 60 * 60 * 24)
    //             let remainingLife = 0
    //             let mean = 0
    //             this.DegradationParameters.forEach(p => {
    //                 let estimatedThickness = 0
    //                 let rLife

    //                 if (p.CurveType == "Linear") {
    //                     if (this.gaugingElements.length > 1) {
    //                         if (p.CurveParameters[0] != 0 || p.CurveParameters[1] != 0) {
    //                             const intercept = p.CurveParameters[0]
    //                             const slope = p.CurveParameters[1]
    //                             const estimatedLostThickness = intercept + (time * slope)

    //                             estimatedThickness = originalThickness - estimatedLostThickness

    //                             const lostThicknessLimit = originalThickness - excessiveCorrosionThickness
    //                             const lifeTime = (lostThicknessLimit - intercept) / slope
    //                             rLife = (lifeTime - time) / 365
    //                             mean++
    //                         } else {
    //                             rLife = 0
    //                         }
    //                     } else {
    //                         if (Number(this.gaugingElements[0]?.gaugingValue) <= this.thickness) {
    //                             const intercept = p.CurveParameters[0]
    //                             const slope = p.CurveParameters[1]
    //                             const estimatedLostThickness = intercept + (time * slope)

    //                             estimatedThickness = originalThickness - estimatedLostThickness

    //                             const lostThicknessLimit = originalThickness - excessiveCorrosionThickness
    //                             const lifeTime = (lostThicknessLimit - intercept) / slope
    //                             rLife = (lifeTime - time) / 365
    //                             mean++
    //                         } else {
    //                             remainingLife = null
    //                         }
    //                     }
    //                 }
    //                 else if (p.CurveType == "Exponential") {
    //                     const a = p.CurveParameters[0]
    //                     const b = p.CurveParameters[1]
    //                     const estimatedLostThickness = a * Math.pow(time, b)

    //                     estimatedThickness = originalThickness - estimatedLostThickness

    //                     const trL = originalThickness - excessiveCorrosionThickness
    //                     const base = trL / a
    //                     const exponent = 1 / b
    //                     const lifeTime = Math.pow(base, exponent)
    //                     rLife = (lifeTime - time) / 365
    //                     mean++
    //                 }
    //                 if (remainingLife !== null) {
    //                     remainingLife = remainingLife + rLife
    //                 } else {
    //                     remainingLife = remainingLife
    //                 }
    //             })
    //             this.RemainingLife = remainingLife / mean
    //         }
    //     }
    // }

    // private setCorrosionRate(referenceDate: Date) {
    //     if (this.DegradationParameters) {
    //         let corrosionRate = 0
    //         let mean = 0
    //         const buildingDate = this.properties.General.Collection.Date
    //         const time = (new Date(referenceDate).getTime() - new Date(buildingDate).getTime()) / (1000 * 60 * 60 * 24)
    //         this.DegradationParameters.forEach(p => {
    //             if (p.CurveType == "Linear") {
    //                 if (this.gaugingElements.length > 1) {
    //                     if (p.CurveParameters[0] != 0 || p.CurveParameters[1] != 0) {
    //                         const slope = p.CurveParameters[1]
    //                         corrosionRate = slope * 365
    //                         mean++
    //                     } else {
    //                         corrosionRate = 0
    //                     }
    //                 } else {
    //                     if (Number(this.gaugingElements[0]?.gaugingValue) <= this.thickness) {
    //                         const slope = p.CurveParameters[1]
    //                         corrosionRate = slope * 365
    //                         mean++
    //                     } else {
    //                         corrosionRate = null
    //                     }
    //                 }
    //             }
    //             else if (p.CurveType == "Exponential") {
    //                 const a = p.CurveParameters[0]
    //                 const b = p.CurveParameters[1]

    //                 corrosionRate = corrosionRate + (365 * a * b * Math.pow(time, b - 1))
    //                 mean++
    //             }
    //         })
    //         if (corrosionRate !== null) {
    //             corrosionRate = corrosionRate / mean
    //         } else {
    //             corrosionRate = corrosionRate
    //         }
    //         this.CorrosionRate = corrosionRate
    //     }
    // }

    // private setAbsoluteDegradation() {
    //     if (this.EstimatedThickness) {
    //         let originalThickness = 0
    //         if (this.properties.TypeName === "Stiffener" || this.properties.TypeName === "Bracket") {
    //             if (this.properties.Geometry.RuleWebThickness === 0 && this.properties.Geometry.RuleFlangeThickness > 0) {
    //                 originalThickness = this.properties.Geometry.RuleFlangeThickness
    //             } else {
    //                 originalThickness = this.properties.Geometry.RuleWebThickness
    //             }
    //         } else {
    //             originalThickness = this.properties.Geometry.RuleThickness
    //         }
    //         this.AbsoluteDegradation = 100.0 * (originalThickness - this.EstimatedThickness) / originalThickness
    //     } else if (isNaN(this.EstimatedThickness)) {
    //         this.AbsoluteDegradation = null
    //     } else {
    //         this.AbsoluteDegradation = 0
    //     }
    // }

    // private setCorrosionRiskIndex() {
    //     if (this.AbsoluteDegradation) {
    //         const interfaceRisk = 1
    //         this.CorrosionRiskIndex = this.AbsoluteDegradation * interfaceRisk
    //     } else if (this.AbsoluteDegradation == null) {
    //         this.CorrosionRiskIndex = null
    //     }
    //     else {
    //         this.CorrosionRiskIndex = 0
    //     }
    // }
    //#endregion

    public getMeanThicknessByScope(scope: string): number {
        return this.thicknessGaugingPoints.length > 0 && this.thicknessGaugingPoints.filter(x => x.active && x.scope === scope).filter(x => x.active && x.gaugingValue > 0).length > 0 ?
            this.thicknessGaugingPoints.filter(x => x.active && x.scope === scope).map(x => x.gaugingValue)
                .filter(x => x > 0).reduce((a, b) => a + b, 0) / this.thicknessGaugingPoints.filter(x => x.active && x.scope === scope).filter(x => x.active && x.gaugingValue > 0).length : 0;
    }

    public get thicknessGaugingPoints(): Array<GaugingElement> {
        return this._gaugingElements.filter(x => x.inspectionTypeId === INSPECTIONS_TYPES_IDS.THICKNESS_GAUGING);
    }

    public addGaugingElement(v: GaugingElement): void {
        this._gaugingElements.push(v);
        if (this.properties)
            switch (this.TypeId) {
                case ELEMENTSTYPESIDS.PLATE:
                    this.properties.Computed.AverageThickness = this.meanThicknessValue;
                case ELEMENTSTYPESIDS.FACEPLATE:
                    this.properties.Computed.AverageThickness = this.meanThicknessValue;
                    break;
                case ELEMENTSTYPESIDS.STIFFENER:
                    if (this.properties.Geometry.FlangeThickness)
                        this.properties.Computed.AverageFlangeThickness = this.getMeanThicknessByScope('ONLY FLANGE');

                    if (this.properties.Geometry.WebThickness)
                        this.properties.Computed.AverageWebThickness = this.getMeanThicknessByScope('ONLY WEB');
                    break;
                case ELEMENTSTYPESIDS.BRACKET:
                    if (this.properties.Geometry.FlangeThickness)
                        this.properties.Computed.AverageFlangeThickness = this.getMeanThicknessByScope('ONLY FLANGE');

                    if (this.properties.Geometry.WebThickness)
                        this.properties.Computed.AverageWebThickness = this.getMeanThicknessByScope('ONLY WEB');
                default:
                    break;
            }
    }

    public updateRemainingLifeViewMode(low: number, high: number, remainingLife: number) {
        if (remainingLife || remainingLife == 0) {
            if (remainingLife >= high) this.currentRenderMaterial = StructuralElement._acceptableCorrosionMaterial;

            else if (remainingLife >= low) this.currentRenderMaterial = StructuralElement._substantialCorrosionMaterial;

            else this.currentRenderMaterial = StructuralElement._excessiveCorrosionMaterial;
        }
    }

    public updateCorrosionRateViewMode(low: number, high: number, corrosionRate: number) {
        if (corrosionRate || corrosionRate == 0) {
            if (corrosionRate <= low) this.currentRenderMaterial = StructuralElement._acceptableCorrosionMaterial;

            else if (corrosionRate <= high) this.currentRenderMaterial = StructuralElement._substantialCorrosionMaterial;

            else this.currentRenderMaterial = StructuralElement._excessiveCorrosionMaterial;
        }
    }

    public updateCorrosionRiskIndexViewMode(low: number, high: number, corrosionRiskIndex: number) {
        if (corrosionRiskIndex || corrosionRiskIndex == 0) {
            if (corrosionRiskIndex <= low) this.currentRenderMaterial = StructuralElement._acceptableCorrosionMaterial;

            else if (corrosionRiskIndex <= high) this.currentRenderMaterial = StructuralElement._substantialCorrosionMaterial;

            else this.currentRenderMaterial = StructuralElement._excessiveCorrosionMaterial;
        }
    }

    public updateDegradationRate(estimatedThickness?: number): void {
      let mean = this.meanThicknessValue;
      if (estimatedThickness != null){
        mean = estimatedThickness
      }
      if (mean === 0) return
      if (mean <= this.excessiveCorrosionThickness) this.currentRenderMaterial = StructuralElement._excessiveCorrosionMaterial;
      else if (mean <= this.substantialCorrosionThickness) this.currentRenderMaterial = StructuralElement._substantialCorrosionMaterial;
      else this.currentRenderMaterial = StructuralElement._acceptableCorrosionMaterial;

      // this.properties.Computed.AverageThickness = mean;
      this.setComputedProperties(mean);
      // switch (this.TypeId) {
      //     case ELEMENTSTYPESIDS.PLATE:

      //         break;
      //     case ELEMENTSTYPESIDS.STIFFENER:
      //         break;
      //     case ELEMENTSTYPESIDS.FACEPLATE:
      //         break;
      //     case ELEMENTSTYPESIDS.BRACKET:
      //         break;
      //     default:
      //         break;
      // }
    }

    public setComputedProperties(mean: number): void {
        this.properties.Computed = {
            AverageThickness: mean ?? 0,
            Weight: this.weight ?? 0,
            Area:this.Area,//?this.area*1000:0,
            Height: this.Height,
            Width:this.Width
        }
    }

    public get height():number{
        return this.ComputeHeight();
    }

    public get width():number{
        return this.ComputeWidth();
    }

    public get weight(): number {
        return this.ComputeWeight(this.area * Math.abs(this.thickness) * 0.001);
    }

    public get _excessiveCorrosionThickness(): number {
        if (!(this.gaugingElements.length == 1 && Number(this.gaugingElements[0]?.gaugingValue) > this.thickness)) {
            return Math.abs(this.ruleThickness) * (1 - Math.abs(this.admissibleCorrosion) / 100);
        } else {
            return 0
        }
    }

    public get _substantialCorrosionThickness(): number {
        if (!(this.gaugingElements.length == 1 && Number(this.gaugingElements[0]?.gaugingValue) > this.thickness)) {
            return Math.abs(this.ruleThickness) * (1 - 0.75 * Math.abs(this.admissibleCorrosion) / 100);
        } else {
            return 0
        }
    }

    public GetMaterial(): Material {
        return new Material(this.MaterialType, this.MaterialSubType);
    }

    private ComputeWeight(volume: number): number {
        if (!this.MaterialType) return 0;
        if (Util.isNullOrUndefined(this.MaterialType.materialSubType.density) &&
            (Util.isNullOrUndefined(this.MaterialSubType) || Util.isNullOrUndefined(this.MaterialSubType.density))) {
            return 0;
        }
        // computes the weight in kg, density is in kg/m3 and thickness is in mm.
        volume = Math.abs(volume);
        if (this.MaterialSubType && this.MaterialSubType.density) {
            return volume * this.MaterialSubType.density * 1000000000;
        }
        else {
            return volume * this.MaterialType.materialSubType.density * 1000000000;
        }
    }



    private ComputeHeight():number{
        return 0;
    }

    private ComputeWidth():number{
        return 0;
    }
}
